'use client'

interface GenAiIconProps {
    size?: number
    strokeColor?: string
}

/** Sparkles/AI icon used in WidgetGenAi, WidgetGetStartedCta, etc. */
export function GenAiIcon({ size = 40, strokeColor = 'var(--gm-fg-highlight)' }: GenAiIconProps) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 48 48" fill="none">
            <path
                d="M13 26L14.5689 29.1378C15.0999 30.1998 15.3654 30.7308 15.7201 31.1909C16.0348 31.5992 16.4008 31.9652 16.8091 32.2799C17.2692 32.6346 17.8002 32.9001 18.8622 33.4311L22 35L18.8622 36.5689C17.8002 37.0999 17.2692 37.3654 16.8091 37.7201C16.4008 38.0348 16.0348 38.4008 15.7201 38.8091C15.3654 39.2692 15.0999 39.8002 14.5689 40.8622L13 44L11.4311 40.8622C10.9001 39.8002 10.6346 39.2692 10.2799 38.8091C9.96522 38.4008 9.59919 38.0348 9.19089 37.7201C8.73077 37.3654 8.19979 37.0999 7.13783 36.5689L4 35L7.13783 33.4311C8.19979 32.9001 8.73077 32.6346 9.19089 32.2799C9.59919 31.9652 9.96522 31.5992 10.2799 31.1909C10.6346 30.7308 10.9001 30.1998 11.4311 29.1378L13 26Z"
                stroke={strokeColor}
                strokeWidth={3}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M30 4L32.3572 10.1288C32.9213 11.5953 33.2033 12.3285 33.6418 12.9453C34.0305 13.4919 34.5081 13.9695 35.0547 14.3582C35.6715 14.7967 36.4047 15.0787 37.8712 15.6428L44 18L37.8712 20.3572C36.4047 20.9213 35.6715 21.2033 35.0547 21.6418C34.5081 22.0305 34.0305 22.5081 33.6418 23.0547C33.2033 23.6715 32.9213 24.4047 32.3572 25.8712L30 32L27.6428 25.8712C27.0787 24.4047 26.7967 23.6715 26.3582 23.0547C25.9695 22.5081 25.4919 22.0305 24.9453 21.6418C24.3285 21.2033 23.5953 20.9213 22.1288 20.3572L16 18L22.1288 15.6428C23.5953 15.0787 24.3285 14.7967 24.9453 14.3582C25.4919 13.9695 25.9695 13.4919 26.3582 12.9453C26.7967 12.3285 27.0787 11.5953 27.6428 10.1288L30 4Z"
                stroke={strokeColor}
                strokeWidth={3}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
